// Fetch Request
import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {

  const query = `
    mutation (
      $title1: String,
      $title1_en: String,
      $title1_fr: String,
      $title1_it: String,
      $title1_pt: String,
      $content1: String,
      $content1_en: String,
      $content1_fr: String,
      $content1_it: String,
      $content1_pt: String,
      $title2: String,
      $title2_en: String,
      $title2_fr: String,
      $title2_it: String,
      $title2_pt: String,
      $content2: String,
      $content2_en: String,
      $content2_fr: String,
      $content2_it: String,
      $content2_pt: String,
      $title3: String,
      $title3_en: String,
      $title3_fr: String,
      $title3_it: String,
      $title3_pt: String,
      $content3: String,
      $content3_en: String,
      $content3_fr: String,
      $content3_it: String,
      $content3_pt: String,
    ) {
      CreateFooterSetting (
        title1: $title1,
        title1_en: $title1_en,
        title1_fr: $title1_fr,
        title1_it: $title1_it,
        title1_pt: $title1_pt,
        content1: $content1,
        content1_en: $content1_en,
        content1_fr: $content1_fr,
        content1_it: $content1_it,
        content1_pt: $content1_pt,
        title2: $title2,
        title2_en: $title2_en,
        title2_fr: $title2_fr,
        title2_it: $title2_it,
        title2_pt: $title2_pt,
        content2: $content2,
        content2_en: $content2_en,
        content2_fr: $content2_fr,
        content2_it: $content2_it,
        content2_pt: $content2_pt,
        title3: $title3,
        title3_en: $title3_en,
        title3_fr: $title3_fr,
        title3_it: $title3_it,
        title3_pt: $title3_pt,
        content3: $content3,
        content3_en: $content3_en,
        content3_fr: $content3_fr,
        content3_it: $content3_it,
        content3_pt: $content3_pt,
      ) {
          status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.CreateFooterSetting.status === "success") {
    showToaster({ messageId: 'footerSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'footerSettingsUpdateFailed', toasterType: 'error' })
  }

}

export default submit;
